import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { forwardRef, useContext, useEffect, useState } from 'react'
import ModalFecharOrdemServico from '../../ModalFecharOrdemServico/ModalFecharOrdemServico'
import { WebSocketContext } from '../../../../Providers/WebSocket/WebSocketContext'
import { showNotify } from '../../../../Utils/Utils'
import { saveAs } from 'file-saver'
import { Buffer } from 'buffer'
import ModalCancelarOrdemServico from '../../ModalCancelarOrdemServico/ModalCancelarOrdemServico'
import { CircularProgress } from '@mui/material'
import { OrdemServicoContext } from '../../../../Providers/OrdemServicoContext/OrdemServicoContext'
import { disabledOptionSx, invisibleDiv, modalSx, optionSx } from './ModalOpcoesOrdemServicoSx'

const ModalOpcoesOrdemServico = forwardRef(({ idOrdemServico, setOpen }, ref) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { imprimindo, setImprimindo } = useContext(OrdemServicoContext)

    const [openModalFecharOrdemServico, setOpenModalFecharOrdemServico] = useState(false)
    const [openModalCancelarOrdemServico, setOpenModalCancelarOrdemServico] = useState(false)

    const [ordemServico, setOrdemServico] = useState(false)

    useEffect(() => {
        sendWs('buscarOrdemServico#modalOpcoes', { id: idOrdemServico })
    }, [])

    addRoute('buscarOrdemServico#modalOpcoes', (msg) => {
        const { status } = msg.data

        if (status == 'error' || !status) {
            ordemServico.current = null
            return
        }

        setOrdemServico(msg.data.ordemServico)
    })

    addRoute('imprimirOrdemServico', (msg) => {
        setImprimindo(false)
        const { status, message } = msg.data

        if (status == 'error' || !status) {
            showNotify('error', message)
            return
        }

        const ordemServicoPDF = new Blob([Buffer.from(msg.data.buffer)], { type: 'application/pdf' })

        saveAs(ordemServicoPDF)
    })

    const imprimir = () => {
        if (!imprimindo) {
            setImprimindo(true)
            sendWs('imprimirOrdemServico', { id: idOrdemServico })
        }
    }

    const podeFecharOuCancelarOrdemServico = () => {
        return ordemServico && ordemServico.status !== 3 && ordemServico.status !== 4
    }

    const handleFecharModal = (status) => {
        setOpen(status)
    }

    return (
        <>
            {openModalFecharOrdemServico && <ModalFecharOrdemServico open={openModalFecharOrdemServico} setOpen={handleFecharModal} ordemServicoRef={ordemServico}/>}
            {openModalCancelarOrdemServico && <ModalCancelarOrdemServico open={openModalCancelarOrdemServico} setOpen={handleFecharModal} ordemServicoRef={ordemServico}/>}
            <Grid sx={invisibleDiv} onClick={() => handleFecharModal(false)}/>
            <Grid style={modalSx} ref={ref}>
                {podeFecharOuCancelarOrdemServico()
                    ? <Grid sx={optionSx} onClick={() => setOpenModalFecharOrdemServico(true)}>
                        Fechar OS
                    </Grid>
                    : <Grid sx={disabledOptionSx}>
                        Fechar OS
                    </Grid>
                }
                <Grid sx={{ ...optionSx, display: 'flex', gap: '10px' }} onClick={() => imprimir()}>
                    Imprimir
                    {imprimindo && <CircularProgress color="inherit" size="1rem"/>}
                </Grid>
                {podeFecharOuCancelarOrdemServico()
                    ? <Grid sx={optionSx} onClick={() => setOpenModalCancelarOrdemServico(true)}>
                        Cancelar OS
                    </Grid>
                    : <Grid sx={disabledOptionSx}>
                        Cancelar OS
                    </Grid>
                }
                {/* Enviar Whatsapp <br/> */}
            </Grid>
        </>
    )
})

export default ModalOpcoesOrdemServico
